var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-settings std-view"},[_c('main',{staticClass:"main"},[_c('h1',[_vm._v("Contacts")]),_c('ContactList',{attrs:{"edit-mode":""}})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }